import actions from 'src/modules/interaction/form/interactionFormActions';
import interactionMeetingNotesActions from 'src/modules/interaction/shared/interactionMeetingNotesActions';

const initialData = {
  initLoading: false,
  saveLoading: false,
  record: null,
  duplicateResults: null
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.INIT_STARTED) {
    return {
      ...state,
      record: null,
      initLoading: true,
    };
  }

  if (type === actions.INIT_SUCCESS) {
    return {
      ...state,
      record: payload,
      initLoading: false,
    };
  }

  if (type === actions.INIT_ERROR) {
    return {
      ...state,
      record: null,
      initLoading: false,
    };
  }

  if (type === actions.CREATE_STARTED) {
    return {
      ...state,
      saveLoading: true,
    };
  }

  if (type === actions.CREATE_SUCCESS) {
    return {
      ...state,
      record: payload,
      saveLoading: false,
    };
  }

  if (type === actions.CREATE_ERROR) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === actions.UPDATE_STARTED) {
    return {
      ...state,
      saveLoading: true,
    };
  }

  if (type === actions.UPDATE_SUCCESS) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === actions.UPDATE_ERROR) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === actions.DUPLICATE_CHECK_STARTED) {
    return {
      ...state,
    };
  }

  if (type === actions.DUPLICATE_CHECK_SUCCESS) {
    return {
      ...state,
      duplicateResults: payload,
    };
  }

  if (type === actions.DUPLICATE_CHECK_ERROR) {
    return {
      ...state,
    };
  }

  if (type === interactionMeetingNotesActions.ADD_NOTE_SUCCESS) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === interactionMeetingNotesActions.ADD_NOTE_ERROR) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === interactionMeetingNotesActions.UPDATE_NOTE_SUCCESS) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === interactionMeetingNotesActions.UPDATE_NOTE_ERROR) {
    return {
      ...state,
      saveLoading: false,
    };
  }

  if (type === interactionMeetingNotesActions.DELETE_NOTE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === interactionMeetingNotesActions.DELETE_NOTE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};
